export default __webpack_public_path__ + "static/media/5.64ea4d70.jpg";